import { render, staticRenderFns } from "./NumeroOrdenDeCompra.vue?vue&type=template&id=525cc9b6&"
import script from "./NumeroOrdenDeCompra.vue?vue&type=script&lang=js&"
export * from "./NumeroOrdenDeCompra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports